import angular from 'angular'
import StrictObj from '../utils/strict-obj'

import { MOBILE_THRESHOLD } from '../utils/shared-constants'

angular
  .module('ggs.gallery')
  .factory('OverridesManager', OverridesManagerProvider)

function OverridesManagerProvider(
  rootResize,
  DefineMethod,
  DefineHandler) {

  return function OverridesManager(properties) {

    const sign = 'galleryMain::overridesManager'
    const manager = StrictObj({
      wrapM: DefineMethod(sign),
      wrapH: DefineHandler(sign)
    })

    manager.wrapM('init', () => {
      manager.overrideBodyMargin()
      manager.overrideCarouselScrollbarSize()
      manager.overrideScrollToPreviewOnModalChange()
      rootResize.width.on(manager.overrideBodyMargin)
      rootResize.width.on(manager.overrideCarouselScrollbarSize)
      rootResize.width.on(manager.overrideScrollToPreviewOnModalChange)
    })

    manager.wrapM('destroy', () => {
      rootResize.width.off(manager.overrideBodyMargin)
      rootResize.width.off(manager.overrideCarouselScrollbarSize)
      rootResize.width.off(manager.overrideScrollToPreviewOnModalChange)
    })

    manager.wrapH('overrideBodyMargin', () => {
      const disable = rootResize.getWidth() < MOBILE_THRESHOLD
      return disable
        ? properties.override('body_side_margin', 0)
        : properties.unoverride('body_side_margin')
    })

    manager.wrapH('overrideCarouselScrollbarSize', () => {
      const tiny = rootResize.getWidth() < MOBILE_THRESHOLD
      return tiny
        ? properties.override('carousel_scrollbar_size', 5)
        : properties.unoverride('carousel_scrollbar_size')
    })

    manager.wrapH('overrideScrollToPreviewOnModalChange', () => {
      const disable = rootResize.getWidth() < MOBILE_THRESHOLD
      return disable
        ? properties.override('scroll_to_preview_on_modal_change', false)
        : properties.unoverride('scroll_to_preview_on_modal_change')
    })

    return manager
  }
}
